var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-search",
    {
      directives: [
        {
          name: "shortkey",
          rawName: "v-shortkey",
          value: { lower: ["f"], upper: ["shift", "f"] },
          expression: "{ lower: ['f'], upper: ['shift', 'f'] }"
        }
      ],
      ref: "search",
      staticClass: "search-input",
      attrs: {
        "inverted-light": "",
        color: "transparent",
        placeholder: _vm.placeholder
      },
      nativeOn: {
        shortkey: function($event) {
          return _vm.focusSearch($event)
        }
      },
      model: {
        value: _vm.search,
        callback: function($$v) {
          _vm.search = $$v
        },
        expression: "search"
      }
    },
    [
      _c("q-autocomplete", {
        ref: "autocomplete",
        attrs: {
          debounce: _vm.defaultSearchDebounce,
          "min-characters": 0,
          "value-field": function() {
            return _vm.search
          }
        },
        on: { search: _vm.handleSearch, selected: _vm.selected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }